import { withTheme } from "@material-ui/core";
import { NewInput } from "@volt_developers/react-ui-components";
import { useLayoutEffect, useRef } from "react";
import { Control, Controller, FieldErrors } from "react-hook-form";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { FIELD_REQUIRED } from "../../../../constants/errors";
import { useErrorCodeTranslation } from "../../../../hooks/errors";
import { useOperationState } from "../../../../hooks/operationsState";
import { numericInputPattern } from "../../../../utils";
import { operationPath } from "../../store";

import type { TwoFAConfirmationCode } from "../../models/TwoFAConfirmationCode";

interface CodeInputProps {
  control: Control<TwoFAConfirmationCode>;
  errors: FieldErrors<TwoFAConfirmationCode>;
  "data-testid"?: string;
}

function CodeInput({
  control,
  errors,
  "data-testid": dataTestId,
}: CodeInputProps) {
  const { t } = useTranslation();
  const { et } = useErrorCodeTranslation();
  const { operationLoading, operationError } = useOperationState(
    operationPath.enableTwoFA,
    {
      defaultLoading: false,
    }
  );
  const inputRef = useRef<HTMLInputElement | null>(null);

  useLayoutEffect(() => {
    inputRef?.current?.focus();
  }, [operationError]);

  return (
    <Controller
      control={control}
      name="code"
      render={({ field }) => (
        <Wrapper>
          <NewInput
            {...field}
            data-testid={dataTestId}
            autoComplete="off"
            size="large"
            inputRef={inputRef}
            label={t("Confirmation code")}
            error={Boolean(errors.code)}
            errorText={errors.code?.message}
            disabled={operationLoading}
            fullWidth
            onChange={(event) =>
              field.onChange(
                event.target.value.replace(numericInputPattern, "")
              )
            }
          />
        </Wrapper>
      )}
      rules={{
        required: et(FIELD_REQUIRED),
      }}
    />
  );
}

export default CodeInput;

const Wrapper = withTheme(styled.div`
  margin-bottom: ${({ theme }) => `${theme.spacing(1)}px`};
  min-height: 75px;
`);
